import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { Link } from "react-router-dom";

const ScamCheckLanding = () => {
  useDocTitle("ZelT | Scam Check");

  return (
    <div>
      <NavBar />
      <div
        className="w-full py-16"
        style={{ background: "linear-gradient(160deg, #0f172a, #1e3a8a)", minHeight: "calc(100vh - 180px)" }}
      >
        <div className="mx-4 max-w-3xl mx-auto text-center" data-aos="zoom-in">
          <span className="text-6xl">🛡️</span>
          <h1 className="text-5xl font-extrabold text-white mt-4 mb-4">
            Scam Check
          </h1>
          <p className="text-xl text-teal-200 mb-4">
            Your digital second opinion.
          </p>
          <p className="text-gray-300 max-w-2xl mx-auto leading-relaxed mb-10">
            Received a scary "your account has been suspended" message? A text
            from your "grandchild"? A pop-up demanding a phone call? Don't
            wonder and don't risk it — paste it here and get a plain-language
            verdict in seconds.
          </p>

          <div className="bg-white/10 rounded-2xl p-8 border border-white/10 mb-10">
            <h2 className="text-white font-bold text-xl mb-6">
              What Scam Check spots:
            </h2>
            <div className="grid gap-4 sm:grid-cols-2 text-left">
              {[
                ["📧", "Phishing emails pretending to be your bank"],
                ["💬", "Scam texts about packages, accounts, or family"],
                ["🖥️", "Fake pop-ups demanding a phone call"],
                ["🔗", "Links that don't go where they claim"],
                ["🧾", "Fake invoices and too-good-to-be-true offers"],
                ["📷", "Screenshots of anything suspicious"],
              ].map(([icon, text]) => (
                <div key={text} className="flex gap-3 items-start">
                  <span className="text-2xl">{icon}</span>
                  <p className="text-gray-300 text-sm">{text}</p>
                </div>
              ))}
            </div>
          </div>

          <Link
            to="/scam-check"
            className="inline-block px-8 py-4 rounded-2xl text-xl font-extrabold text-blue-900 shadow-2xl hover:scale-105 transition"
            style={{ background: "linear-gradient(90deg, #12bfbe, #9198e5)" }}
          >
            🛡️ Check a Suspicious Message
          </Link>

          <p className="text-gray-400 text-sm mt-8">
            Members-only (membership is free —{" "}
            <Link to="/membership" className="underline text-teal-300">
              join here
            </Link>
            ). Your submissions are analyzed and never stored.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ScamCheckLanding;
